import Api from "@/services/Api";

export default {
  getUser() {
    return Api.get("/user");
  },

  getUserLevelCounts() {
    return Api.get("/user_level_counts");
  },

  getUserRevenue() {
    return Api.get("/user/revenue");
  },

  getUserOnboardingSteps() {
    return Api.get(`/user/onboarding`);
  }
};
